import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
export var createFakeUnauthorizedResponse = function createFakeUnauthorizedResponse() {
  var err = new Error('Unauthorized');
  _Object$assign(err, {
    __maskedError: true,
    data: {
      userFacingError: 'Invalid session token.'
    },
    body: {
      errors: [{
        detail: 'Invalid session token.',
        title: 'unauthorized'
      }]
    },
    response: {
      ok: false,
      status: 401
    }
  });
  return err;
};
export var createFakeSuccessfulLogoutResponse = function createFakeSuccessfulLogoutResponse() {
  return {
    response: {
      ok: true,
      status: 204
    }
  };
};